"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Gimp = function Gimp(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M23.58 2.4c-.963 1.206-2.55 6.476-11.46 6.71-4.253.112-6.36-4.731-6.36-4.731l-.334 7.771c-.831-1.042-1.945-1.705-3.014-1.74a2.23 2.23 0 00-1.441.441c-.663.502-.977 1.345-.97 2.28.006.934.33 1.965.97 2.896.64.931 1.476 1.587 2.324 1.89.456.164.916.214 1.35.157C10.674 22.882 26.797 26.557 23.58 2.4zM8.404 8.85c1.265 0 2.314.94 2.614 2.196.484-1.19 1.614-2.027 2.931-2.027 1.758 0 3.178 1.49 3.178 3.322 0 1.833-1.42 3.334-3.178 3.334-1.531 0-2.81-1.14-3.115-2.644-.437.978-1.353 1.666-2.43 1.666-.915 0-1.716-.497-2.203-1.246a5.726 5.726 0 00-.289-.567 3.118 3.118 0 01-.205-1.113c0-1.604 1.198-2.922 2.697-2.922zm0 .36c-1.284 0-2.33 1.138-2.33 2.561s1.046 2.559 2.33 2.559c.214 0 .417-.043.614-.102a1.676 1.759 0 01-1.614-1.756 1.676 1.759 0 011.676-1.758 1.676 1.759 0 011.635 1.373c.012-.105.029-.207.029-.316 0-1.423-1.056-2.56-2.34-2.56zm5.545.131c-1.576 0-2.86 1.334-2.86 3 0 1.667 1.284 3.008 2.86 3.008.591 0 1.14-.188 1.596-.512a2.146 2.252 0 01-.858.19 2.146 2.252 0 01-2.144-2.252 2.146 2.252 0 012.144-2.252 2.146 2.252 0 012.112 1.845l.003-.026c0-1.667-1.277-3-2.853-3zm-11.545 1.39c1.038.035 2.206.77 3.008 1.936.606.882.914 1.866.92 2.727.006.861-.282 1.589-.846 2.016-.564.426-1.31.48-2.082.205-.772-.277-1.564-.883-2.17-1.764-.605-.881-.911-1.867-.917-2.728-.007-.862.282-1.589.845-2.016a1.92 1.92 0 011.242-.375zm11.69.245a1.006 1.056 0 00-1.006 1.059 1.006 1.056 0 001.006 1.054 1.006 1.056 0 001.005-1.054 1.006 1.056 0 00-1.005-1.059zm-5.645.22a.662.695 0 00-.662.694.662.695 0 00.662.697.662.695 0 00.662-.697.662.695 0 00-.662-.693zm-6.414.223a1.118 1.408 0 00-1.119 1.407 1.118 1.408 0 001.12 1.408 1.118 1.408 0 001.116-1.408 1.118 1.408 0 00-1.117-1.407zm14.176 3.998s1.487.435 2.011 1.145c.523.708.194 1.145.057 2.05-.202-.528-.407-.942-.621-1.183-.81 1.259-3.104 1.858-6.18 1.559 1.38-.072 2.451-.288 3.301-.584-1.4.09-3.214-.27-5.365-1.067 4.262.895 6.433.063 7.703-.966-.335-.455-.906-.954-.906-.954z"
  }));
};

Gimp.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Gimp.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Gimp;
exports.default = _default;